<div class="row">
    <div class="col-xs-12">
        <div class="card card-block card--box card--box--dashboard card--box--dashboard__item">
            <div class="mx-auto card--box--dashboard__item__header">
                <h2>
                    {{ 'User numbers' | translate }}
                </h2>
            </div>

            <ng-container>

                <highcharts-chart
                        *ngIf="loadedData"
                        [Highcharts]="Highcharts"
                        [options]="chartOptions"
                        [(update)]="chartGenerated"
                        style="width: 100%; height: 400px; display: block;"
                ></highcharts-chart>

                <form class="hidden" id="frmExport" action="{{authService.baseUrl}}insurance-dashboard/export" method="POST">
                    <textarea id="image-content" name="image" *ngIf="chartBase64">
                        {{ chartBase64 }}
                    </textarea>
                </form>
                <img class="hidden" *ngIf="chartBase64" [src]="chartBase64"/>
                <div class="hidden mx-auto card--box--dashboard__item__filter">
                    <div class="row form-group">
                        <div class="col-xs-3 mr-t--md" *ngFor="let chart of chartTypes">
                            <input type="radio"
                                   [checked]="selectedChart == chart"
                                   [(ngModel)]="selectedChart"
                                   [value]="chart"
                                   id="chartType-{{chart['value']}}"
                                   (change)="getItems()" />
                            <label for="chartType-{{chart['value']}}">{{ chart['name'] | translate }}</label>
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-template #noData>
                <div class="card card--box--dashboard__item__block mental-check mr-t--md text-center">
                    {{ message | translate}}
                </div>
            </ng-template>
        </div>
    </div>
</div>